const endpoints = {
    egresos:'/egresos',
    // exportTeacherList:'/user/teachers/export'
}
export {endpoints}